import {Injectable, Component} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {SystemUtils} from './systemutils';
import {ISportUtils} from './isport-utils';

@Injectable()
export class BasketballUtils implements ISportUtils {
    private systemUtils: SystemUtils;

    constructor(systemUtils:SystemUtils) {
        this.systemUtils = systemUtils;
    }

    public getPlayingSurfaceDimensions() {
        return {
            xs: { width: 300, height: 157, imageSize: 16 },
            sm: { width: 800, height: 418, imageSize: 16 },
            md: { width: 800, height: 418, imageSize: 16 },
            lg: { width: 800, height: 418, imageSize: 16 }
        };
    }

    public formatPeriodTime(periodTime: number) {
        let minutes: string = Math.floor(periodTime / 60) + "";
        if (minutes.length < 2) {
            minutes = "0" + minutes;
        }

        let seconds: string = (periodTime % 60) + "";
        if (seconds.length < 2) {
            seconds = "0" + seconds;
        }

        return minutes + ":" + seconds;
    }

    public getPeriodLabel(periodNum: number, includeOrdinal: boolean, seasonType: string) {
        let perLabel: string = periodNum + "";

        if (periodNum <= 4) {
            if (includeOrdinal) {
                perLabel += this.systemUtils.getOrdinalSuffix(periodNum);
            }
        } else {
            perLabel = "OT";
            if (periodNum > 5) {
                perLabel += (periodNum - 4);
            }
        }

        return perLabel;
    }

    public getOutcomeSuffix(numPeriods: number, seasonType: string) {
        let suffix: string = "";

        if (numPeriods > 4) {
            suffix = " (OT)";
        }

        return suffix;
    }

    public setOutcomeAttributes(gameObj, gameDTO, teamId: number) {
        if (gameDTO.playStatus === "COMPLETED" || gameDTO.playStatus === "UPDATING") {
            if (gameDTO.awayTeamCtx.team.id === teamId) {
                if (gameDTO.awayScore > gameDTO.homeScore) {
                    gameObj._outcome = "W";
                } else {
                    gameObj._outcome = "L";
                }
            } else {
                if (gameDTO.awayScore < gameDTO.homeScore) {
                    gameObj._outcome = "W";
                } else {
                    gameObj._outcome = "L";
                }
            }

            if (gameDTO.latestPeriodType === "BSKTBL_OVERTIME") {
                gameObj._isOvertime = true;
            }
        } else if (gameDTO.playStatus == "UNPLAYED") {
            //TODO: determine what to display
        } else if (gameDTO.playStatus == "IN_PROGRESS") {
            //TODO: determine what to display
        }

        return gameObj;
    }

    public resetProfilePlayersForTeam(thisObj: any, teamId: number) {
        if (teamId === thisObj.game.awayTeamCtx.team.id) {
            thisObj.profileAwayPlayers = [];
        } else {
            thisObj.profileHomePlayers = [];
        }
    }

    public populateProfilePlayerForTeam(thisObj: any, gameObj: any, player: any, teamId: number) {
        if (teamId === gameObj.awayTeamCtx.team.id) {
            thisObj.profileAwayPlayers.push(player);
        } else {
            thisObj.profileHomePlayers.push(player);
        }
    }

    public getGameEventTypes() {
        let gameEventTypes: any = {
            typesAndServices: [
                { name: "fieldgoalattempt", responseAttr: "fieldGoalAttempts" },
                { name: "freethrowattempt", responseAttr: "freeThrowAttempts" },
                { name: "rebound",          responseAttr: "rebounds" },
                { name: "turnover",         responseAttr: "turnovers" },
                { name: "foul",             responseAttr: "fouls" },
                { name: "substitution",     responseAttr: "substitutions" },
                { name: "violation",        responseAttr: "violations" },
                { name: "jumpball",         responseAttr: "jumpBalls" }
            ],

            orderedTypes: ["fieldgoalattempt",
                "freethrowattempt",
                "rebound",
                "turnover",
                "foul",
                "substitution",
                "violation",
                "jumpball"]
        };

        return gameEventTypes;
    }

    public convertGameEventType(type: string, useCaps: boolean = false) {
        var eventType = "";

        switch (type) {
            case "BSKTBL_FIELDGOAL_ATTEMPT":
                if (useCaps) {
                    eventType = "FieldGoalAttempt";
                } else {
                    eventType = "fieldgoalattempt";
                }
                break;

            case "BSKTBL_FREETHROW_ATTEMPT":
                if (useCaps) {
                    eventType = "FreeThrowAttempt";
                } else {
                    eventType = "freethrowattempt";
                }
                break;

            case "BSKTBL_REBOUND":
                if (useCaps) {
                    eventType = "Rebound";
                } else {
                    eventType = "rebound";
                }
                break;

            case "BSKTBL_TURNOVER":
                if (useCaps) {
                    eventType = "Turnover";
                } else {
                    eventType = "turnover";
                }
                break;

            case "BSKTBL_FOUL":
                if (useCaps) {
                    eventType = "Foul";
                } else {
                    eventType = "foul";
                }
                break;

            case "BSKTBL_SUBSTITUTION":
                if (useCaps) {
                    eventType = "Substitution";
                } else {
                    eventType = "substitution";
                }
                break;

            case "BSKTBL_VIOLATION":
                if (useCaps) {
                    eventType = "Violation";
                } else {
                    eventType = "violation";
                }
                break;

            case "BSKTBL_JUMP_BALL":
                if (useCaps) {
                    eventType = "JumpBall";
                } else {
                    eventType = "jumpball";
                }
                break;

            default:
                break;
        }

        return eventType;
    }

}
